import { CodeFieldIncludeInactiveValues } from 'app/area/codetable/types-store';

export const codeFieldIncludeInactive: CodeFieldIncludeInactiveValues = {
  active: {
    enabled: false
  },
  all: {
    enabled: true
  }
};
